import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * FEATURE TOGGLES SERVICE
 *
 * Notes:
 * - Toggles are initialized in the App entry point - in order to guarantee they are available within all components
 *   e.g index.jsx page for react or _app.jsx for next.js
 * - New toggles must be created for every region
 * - Toggles are always defaulting to FALSE
 *
 * Toggle Format:
 * --------------
 * "toggle-name": {
 *   "isEnabled": false
 * }
 *
 * Usage in code:
 * ------
 * import { isToggleEnabled } from '@paddl/utils-js';
 *
 * initFeatureToggles();
 *
 * if (isToggleEnabled('my-feature')) {
 *   ...
 * }
 *
 * * Usage in the browser:
 * ------
 *  Override state for toggle: 'show-logo'
 *  localStorage.setItem('toggle:show-logo', true);
 */

/* eslint-disable no-prototype-builtins */

import features from './features';
import { overridableLocalData } from '../localDataStoreService';
var toggles = {};
var getOverrideKey = function getOverrideKey(toggleName) {
  return "toggle:".concat(toggleName);
};

// Parse a raw feature toggle and check for local override
var parseToggle = function parseToggle(key, value) {
  var override = overridableLocalData(getOverrideKey(key), value.isEnabled);
  return _objectSpread(_objectSpread({}, value), {}, {
    isEnabled: override.toString() === 'true'
  });
};

// Load feature toggle set that checks for localStorage overrides for each toggle
export var initFeatureToggles = function initFeatureToggles() {
  try {
    toggles = Object.entries(features).reduce(function (items, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      return _objectSpread(_objectSpread({}, items), {}, _defineProperty({}, key, parseToggle(key, value)));
    }, {});
  } catch (err) {
    throw new Error('Failed to load & parse features');
  }
};

// Extract a toggle
var getToggle = function getToggle(toggleName) {
  if (!toggles.hasOwnProperty(toggleName)) {
    throw new Error("Feature Toggle '".concat(toggleName, "' not defined"));
  }
  return toggles[toggleName];
};

// Read a feature toggle state. Defaults to FALSE on error
export var isToggleEnabled = function isToggleEnabled(toggleName) {
  try {
    return !!getToggle(toggleName).isEnabled;
  } catch (err) {
    return false;
  }
};